import { Box, Button, Collapse, Stack, Typography, useTheme } from '@mui/material';
import { useAppSelector } from 'hooks/redux.hooks';
import { useNavigate } from 'react-router-dom';
import { selectTranslations } from 'state/reducers/translation.reducers';
import { getUserDetails } from 'state/reducers/user.reducers';
import ColoredArea from 'components/ColoredArea';
import { pagesEnum } from 'constants/ui.constants';
import Articles from 'components/Articles/Articles';
import DashboardNavbar from 'sections/layout/Navbar';
import { useState } from 'react';
import NoSideBarPage from 'components/NoSideBarPage';
import { FormButton } from 'theme/elements/Buttons';
import { CenteredNarrowContent } from 'theme/elements/Content';
import { FormCard, FormsStack } from 'theme/elements/Forms';
import { FormHeader1 } from 'theme/elements/Headers';
import FormCreator from 'components/FormCreator';
import { fieldsGroupType, fieldType, invalidFields, validationTypes } from 'components/FormCreator/types';

export default function PlanPaymentApp() {
	const navigate = useNavigate();
	const theme = useTheme();
	const t = useAppSelector(selectTranslations);
	const prefixField = 'page.planPayment.';
	const title = t(`${prefixField}title`);
	const formFieldsPrefix = 'page.planPayment.formFields.';

	// const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
	//   const { name, value } = event.target;
	//   updateInput(name, value);
	//   if (_.has(newBankFieldsValidations, name)) {
	//     setInvalidFields(
	//       setListOfInvalids(invalidFields, newBankFieldsValidations, name, value)
	//     );
	//   }
	// };

	// const updateInput = (name, value) => {
	//   if (name === AddBankFields.ACCOUNT_HOLDER_NAME) {
	//     setAccountOwnerName(value);
	//   } else if (name === AddBankFields.BANK_NAME) {
	//     setBankId(value);
	//   } else if (name === AddBankFields.BRANCH_NUMBER) {
	//     setBranchNumber(value);
	//   } else {
	//     setAccountNumber(value);
	//   }
	// };

	// const checkFields = () => {
	//   let obj = {
	//     [AddBankFields.ACCOUNT_HOLDER_NAME]: accountOwnerName,
	//     [AddBankFields.BANK_NAME]: bankName,
	//     [AddBankFields.ACCOUNT_NUMBER]: accountNumber,
	//     [AddBankFields.BRANCH_NUMBER]: branchNumber,
	//     [AddBankFields.FILE]: file?.name || ""
	//   };
	//   return validateFields(newBankFieldsValidations, obj);
	// }

	// const handleSaveClick = () => {
	//   const invalidFields = checkFields();
	//   if (_.keys(invalidFields).length) {
	//     setInvalidFields(invalidFields);
	//   } else {
	//     submitForm(
	//       accountOwnerName,
	//       accountNumber,
	//       branchNumber,
	//       bankId,
	//       file
	//     );
	//   }
	// };

	// const [invalidFields, setInvalidFields] = useState<invalidFields>({});

	// const disabledSubmit = useMemo(() => {
	//   return _.keys(invalidFields).length || !reportType;
	// }, [reportType]);

	// useEffect(()=>{
	//   const invalidFields = checkFields();
	//   if (_.keys(invalidFields).length) {
	//     setDisabledSubmit(true);
	//   } else {
	//     setDisabledSubmit(false);
	//   }
	// },[accountOwnerName, bankId, accountNumber,branchNumber, file]);

	return (
		<NoSideBarPage>
			<Stack spacing={2} sx={{ padding: '24px', alignItems: 'center' }}>
				<Typography variant="h3" sx={{ textAlign: 'center' }}>
					{title}
				</Typography>
				<Stack>
					<CenteredNarrowContent>
						<FormsStack>
							{/* <Collapse in={userMessage.exist}>
                        <CustomAlert severity={userMessage.type} icon={userMessage.icon} text={t(userMessage.text || '')} subText={userMessage.subText}/>
                    </Collapse> */}
						</FormsStack>
						<FormCard>
							<FormHeader1 title={title} />
							<Typography variant="body3" sx={{ marginTop: '0!important' }}>
								{t(`${prefixField}description`)}
							</Typography>
							{/* <FormCreator
                        initialValidation={invalidFields}
                        name="report"
                        handleChange={handleChange}
                        fieldsGroups={[
                            {
                            type: fieldsGroupType.col,
                            fields: [
                                {
                                type: fieldType.select,
                                validation: [validationTypes.requierd],
                                props: {
                                    required: true,
                                    name: ReportInputFields.REPORT_TYPE,
                                    label: reportTypeLabel,
                                    placeholder: reportTypeLabel,
                                    value: reportType,
                                    options: _.values(reportTypes),
                                    disabled: loading
                                },
                                },
                                {
                                type: fieldType.dateRangePicker,
                                validation: [validationTypes.requierd],
                                props: {
                                    required:true,
                                    name: ReportInputFields.DATE_RANGE,
                                    label: dateRangeLabel,
                                    placeholder: dateRangeLabel,
                                    value: dates,
                                    disabled: loading
                                },
                                },
                            ],
                            },
                        ]}
                        /> */}
						</FormCard>
						<Box
							sx={{
								marginTop: '24px',
								display: 'flex',
								flexDirection: 'row-reverse',
								justifyContent: 'space-between',
							}}
						>
							{/* <FormButton>
                        <Button 
                        disabled={disabledSubmit || loading}
                        variant="contained" 
                        onClick={handleSaveClick}
                        sx={{ padding: "15px 48px" }}
                        >
                        {loading ? <CircularProgress sx={{ width: "30px!important", height: "30px!important" }} /> : saveButtonText }   
                        </Button>
                    </FormButton>
                    <FormButton>
                        <Button 
                        onClick={handleCancelEdit}>
                            {cancelButtonText}
                        </Button>
                    </FormButton> */}
						</Box>
					</CenteredNarrowContent>
					<FormButton sx={{ display: 'flex', justifyContent: 'center' }}>
						<Button
							sx={{ width: '55%' }}
							variant="contained"
							onClick={() => {
								navigate(`/${pagesEnum.PLANS}`);
							}}
							// disabled={!selectedPlan || loading}
						>
							{t('portal.actions.selectPlan')}
						</Button>
					</FormButton>
				</Stack>
			</Stack>
		</NoSideBarPage>
	);
}
